var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Main',{attrs:{"lastName":_vm.lastName,"firstName":_vm.firstName}},[(_vm.isDisplay)?_c('keep-alive',[_c('router-view',{staticClass:"px-4 text-left"})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }